<script>
import login from "../pages/Auth/login.vue";

const routes = [{ path: "/login", name: "login", component: login }];

export default routes;
</script>
